// src/admin/pages/Restaurants/MenuFilters.js
import React from "react";
import "./MenuFilters.css";

export default function MenuFilters({
  showActive,
  setShowActive,
  showInactive,
  setShowInactive,
}) {
  return (
    <div className="menu-filters-container">
      <label className="filter-label">
        <input
          type="checkbox"
          checked={showActive}
          onChange={(e) => setShowActive(e.target.checked)}
        />
        <span>Menù Attivi</span>
      </label>

      <label className="filter-label">
        <input
          type="checkbox"
          checked={showInactive}
          onChange={(e) => setShowInactive(e.target.checked)}
        />
        <span>Menù Inattivi</span>
      </label>
    </div>
  );
}
